var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "component-library" }, [
    _c("div", { staticClass: "title-component" }, [_vm._v("COMPONENT")]),
    _vm._v(" "),
    _c("div", { staticClass: "input-search" }, [
      _c("i", { staticClass: "fa fa-search" }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchComponent,
            expression: "searchComponent"
          }
        ],
        attrs: { type: "text", placeholder: "Search", autocomplete: "off" },
        domProps: { value: _vm.searchComponent },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.searchComponent = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _vm.isLoading
      ? _c(
          "div",
          { staticClass: "content-component" },
          [_c("j-skeleton-component-app")],
          1
        )
      : _c(
          "div",
          { staticClass: "content-component" },
          _vm._l(_vm.componentsLibrary, function(section, index) {
            return _c(
              "div",
              { key: section.type, staticClass: "field-section" },
              [
                _c(
                  "p",
                  {
                    staticClass: "title-section",
                    on: {
                      click: function($event) {
                        section.collapse = !section.collapse
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-caret-right",
                      class: { collapsed: section.collapse }
                    }),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          section.section_name +
                            " (" +
                            section.components.length +
                            ")"
                        ) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "draggable",
                  {
                    staticClass: "field-list",
                    class: { collapsed: section.collapse },
                    attrs: {
                      list: section.components,
                      group: {
                        name: "componentLibrary",
                        pull: "clone",
                        put: false
                      }
                    },
                    on: {
                      start: function($event) {
                        _vm.dragStart($event, index)
                      },
                      end: function($event) {
                        _vm.reset($event, index)
                      }
                    }
                  },
                  _vm._l(section.components, function(component) {
                    return _c(
                      "div",
                      { key: component.id, staticClass: "list" },
                      [
                        _c("img", {
                          staticClass: "field-icon field-icon-active",
                          attrs: {
                            src: require("@/assets/new-form-ui/field-icon-active/" +
                              section.type +
                              ".svg")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "field-icon field-icon-default",
                          attrs: {
                            src: require("@/assets/new-form-ui/field-icon/" +
                              section.type +
                              ".svg")
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(component.name.replace(/_/g, " ")))
                        ])
                      ]
                    )
                  })
                ),
                _vm._v(" "),
                section.loadingSeeMore
                  ? _c("j-skeleton-component-app", { attrs: { length: 1 } })
                  : _vm._e(),
                _vm._v(" "),
                section.useSeeMore &&
                !section.loadingSeeMore &&
                !section.hideSeeMore &&
                !section.collapse
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-center align-items-center"
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "btn-see-more",
                            on: {
                              click: function($event) {
                                _vm.configGetDataComponent[index].service(index)
                              }
                            }
                          },
                          [
                            _vm._v("\n          See More "),
                            _c("i", { staticClass: "fa fa-chevron-down" })
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          })
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e7bfc63a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7bfc63a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application-manager/detail/jComponentLibrary.vue
// module id = null
// module chunks = 